import { StubErrorBoundary, StubPage } from '#app/components/stub-page.tsx'
import { type Route } from './+types/index.ts'

export const meta: Route.MetaFunction = () => [
	{ title: 'Säännöt — Frisbeegolf' },
]

export default function Index() {
	return (
		<StubPage
			eyebrow="Frisbeegolf"
			title="Säännöt ja etiketti"
			intro="Pelin viralliset säännöt sekä kentällä noudatettava etiketti."
		/>
	)
}

export { StubErrorBoundary as ErrorBoundary }
